module.exports = __webpack_public_path__ + "static/social-card-80b261a651b3344a78fdfca21986ee1c.png";